/*
 * @Author: liujunhong
 * @Date: 2023/2/12
 * @Desc: 基础Form
 */

import React, { ReactNode } from 'react';
import { Button, Form, FormInstance, Input, InputNumber, Select, DatePicker, Space  } from 'antd';
import { GameServer } from 'gyyx-component-lib';
import SendSms from '@/components/CustomFormControl/SendSms';
import Captcha from '@/components/CustomFormControl/Captcha';
import zhCN from 'antd/es/date-picker/locale/zh_CN';
import './style.less';

zhCN.lang.shortMonths = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
zhCN.lang.shortWeekDays = ['日', '一', '二', '三', '四', '五', '六'];

const {TextArea, Password} = Input;
export const FormLabel = (props: { label: string }) => {
  return <>
    {props.label}<span className="custom_required">*</span></>;
};

const Compact = (props: { children: ReactNode }) => {
  return <Space.Compact>
    {props.children}
  </Space.Compact>;
};
export const FORM_ITEMS: Record<string, any> = {
  INPUT: Input,
  PASSWORD: Password,
  SELECT: Select,
  INPUT_NUM: InputNumber,
  TEXTAREA: TextArea,
  BUTTON: Button,
  SEND_SMS: SendSms,
  CAPTCHA: Captcha,
  GAME_SERVER: GameServer,
  DATE: DatePicker,
  COMPACT: Compact
};

export interface Conditions {
  label?: ReactNode;
  rules?: any[];
  name?: string;
  type: string;
  key: string;
  options?: any;
  render?: () => ReactNode;
  extra?: string | ReactNode;
  itemOptions?: any;
}

interface Props {
  conditions: Array<Conditions>,
  labelCol?: {
    span: number
  }
  wrapperCol?: {
    span: number
  }
  initialValues?: object
  onFinish: (values: any) => void
  form?: FormInstance
  reset?: never
}


const getFormItem = (item: Conditions) => {
  if (item.type === 'TEXT') {
    return item.render && item.render();
  }
  const FormItem = FORM_ITEMS[item.type];
  const {options = {}} = item;

  if(FormItem === FORM_ITEMS.SELECT) {
    return <Select {...options} />
  }

  if(FormItem === FORM_ITEMS.DATE) {
    return <DatePicker locale={zhCN} {...options} />
  }

  if (FormItem === FORM_ITEMS.BUTTON) {
    const text = options.text ? options.text : '提交';
    return <Button className="base_form_submit" {...options} type="submit" htmlType="submit">{text}</Button>;
  }
  return (
    <FormItem
      options={item.options}
      {...options}
      style={{...options.style}}
    ></FormItem>

  );
};


const BaseForm = (props: Props) => {
  const {
    conditions,
    labelCol = {span: 9},
    wrapperCol = {span: 15},
    initialValues,
    onFinish,
    form,
    ...reset
  } = props;

  const onFormFinish = (values: any) => {
    onFinish(values);
  };


  return (
    <Form
      autoComplete="off"
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      initialValues={initialValues}
      onFinish={onFormFinish}
      className={'base_form_wrap'}
      form={form}
      {...reset}
    >
      {conditions.map(item => {
        return (
          <Form.Item
            key={item.key}
            label={item.label}
            rules={item.rules}
            name={item.name}
            extra={item.extra}
            validateTrigger="onBlur"
            {...item.itemOptions}
          >
            {getFormItem(item)}

          </Form.Item>
        );
      })}
    </Form>
  );
};

export default BaseForm;
